import { connect } from "react-redux";
import Prescription from "./form/Prescription";

function PrescriptionModal(props) {
  const { editing, prescription } = props

  return (
    <>
      {(editing?.patient_id || prescription.id) && <div className="exam-setting-modal exam-modal">
        <div className="modal fade" id="prescription-modal" tabIndex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true">
          <div className="modal-dialog m-0" role="document">
            <div className="modal-content bg-light pb-5 px-5">
              {(editing?.showPrescriptionModal || prescription.id) && <Prescription />}
            </div>
          </div>
        </div>
      </div>}
    </>
  )
}

const mapStateToProps = (state) => {
  const { reports: { editing, report }, dashboard: { quickAction } } = state

  return {
    editing,
    prescription: report,
    patient: quickAction.patient,
  }
}

export default connect(mapStateToProps)(PrescriptionModal)